var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gray-box"},[_vm._t("default"),(_vm.loading)?_c('Spinner',{attrs:{"type":"cover"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }